import React from 'react';
import { IconButton, Button, ButtonProps } from '@landr/maestro';
import { noop } from 'utils/noop';
import { FavoriteItem } from 'types';
import useFavoriteButton from 'components/FavoriteButton/useFavoriteButton';
import { PlaceholderButton } from 'components/CommonUi/PlaceholderButton/PlaceholderButton';
import usePlaceholderButton from 'components/CommonUi/PlaceholderButton/usePlaceholderButton';

export interface FavoriteButtonProps extends ButtonProps {
    item: FavoriteItem;
    onClick?: () => void;
    label?: string;
    isPlaceholderAllowed?: boolean;
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = React.memo(
    ({
        item,
        onClick = noop,
        label,
        isPlaceholderAllowed = false,
        children,
        ...props
    }) => {
        const { handleClick, labelText, icon, isFavorited } = useFavoriteButton(
            {
                item,
                onClick,
                label,
            },
        );

        const isPlaceholder = usePlaceholderButton({
            isPlaceholderAllowed,
            isActivated: isFavorited,
        });

        if (isPlaceholder) {
            return <PlaceholderButton />;
        }

        if (children) {
            return (
                <Button
                    onClick={handleClick}
                    aria-label={labelText}
                    icon={icon}
                    aria-pressed={isFavorited}
                    {...props}
                >
                    {children}
                </Button>
            );
        }

        return (
            <IconButton
                onClick={handleClick}
                aria-label={labelText}
                label={labelText}
                icon={icon}
                aria-pressed={isFavorited}
                {...props}
            />
        );
    },
);
